export default __webpack_public_path__ + "static/media/premium-icon.81f76d9a.svg";